import React from 'react';
import classNames from 'classnames';
import isFinite from 'lodash/fp/isFinite';

import Button from 'common/components/Button';
import Modal from 'common/components/modals/Modal';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import CommitmentText from '../components/CommitmentText';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import SubscriptionCommitModalFooter from '../components/SubscriptionCommitModalFooter';

export default class SubscriptionCommitButton extends React.Component {
  state = {
    isOpen: false,
  };

  static propTypes = {
    buttonClass: propTypes.string,
    buttonComponent: propTypes.elementType,
    buttonProps: propTypes.shape(),
    isSubscribed: propTypes.bool.isRequired,
    offering: accountPropTypes.VariantOffering.isRequired,
    price: propTypes.oneOfType([propTypes.number, propTypes.string]),
  };

  static defaultProps = {
    buttonComponent: Button,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  renderModal = () => {
    const { isOpen } = this.state;
    const { offering } = this.props;
    return (
      <Modal
        className="SubscriptionCommitButton__modal"
        bodyClassName="Modal__body--large container"
        isOpen={isOpen}
        onRequestClose={this.closeModal}
      >
        <CommitmentText {...this.props} />
        <SubscriptionCommitModalFooter
          onClose={this.closeModal}
          offering={offering}
          acceptTranslationId={this.acceptTranslationId}
          dismissTranslationId="cart.subscription_commit_button.decline"
        />
      </Modal>
    );
  };

  get acceptTranslationId() {
    return this.props.isSubscribed
      ? 'cart.subscription_commit_button.add_to_cart'
      : 'cart.subscription_commit_button.get_it_with_autoship';
  }

  render() {
    const {
      buttonClass,
      buttonComponent: ButtonComponent,
      buttonProps,
      price,
    } = this.props;
    const buttonClasses = classNames(
      buttonClass,
      'SubscriptionCommitButton button--vivid'
    );

    const optionallyRenderPrice = () =>
      isFinite(price) ? (
        <>
          {' - '}
          <PriceSpan amount={price} />
        </>
      ) : null;

    return (
      <div>
        <ButtonComponent
          onClick={this.openModal}
          className={buttonClasses}
          {...buttonProps}
        >
          <TranslatedMessage id={this.acceptTranslationId} />
          {optionallyRenderPrice()}
        </ButtonComponent>
        {this.renderModal()}
      </div>
    );
  }
}
